var map = {
	"./de.json": 506683,
	"./en.json": 251460,
	"./es.json": 985766,
	"./fr.json": 432590,
	"./it.json": 512930,
	"./ja.json": 668769,
	"./ko.json": 255167,
	"./pl.json": 182051,
	"./pt.json": 721545,
	"./ru.json": 17388,
	"./uk.json": 115624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 642823;